import React from "react";
import { Link } from "react-router-dom";

import "../css/footer.css"
import "../css/main.css"

import footer_1 from "../public/footer/footer_1.png"
import footer_2 from "../public/footer/footer_2.png"
import footer_3 from "../public/footer/footer_3.png"
import footer_4 from "../public/footer/footer_4.png"

import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider"

const Footer = () => {

  const { darkMode } = useContext(DarkModeContext);


  return (
    <>
      <footer className={darkMode ? 'footer dark' : 'footer light'}>
        <div className="footer__left--column">
          <div className="footer__text">
            <p className={darkMode ? 'dark-text' : 'light-text'}>
              Snažíme se ukázat lidem, že Česká republika má spoustu nádherných míst
            </p>
          </div>
          <div className="footer__icons">
            <div className="footer__icon">
              <img src={footer_1} alt="Česká vlajka" />
            </div>
            <div className="footer__icon">
              <img src={footer_2} alt="Hory" />
            </div>
            <div className="footer__icon">
              <img src={footer_3} alt="Batoh" />
            </div>
            <div className="footer__icon">
              <img src={footer_4} alt="Boty" />
            </div>
          </div>
        </div>

        <div className="footer__right--column">
          <div className="footer__column">
            <h4 className={darkMode ? 'dark-text' : 'light-text'}>Pohoří</h4>
            <Link to="/beskydy" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Beskydy</Link>
            <Link to="/jeseniky" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Jeseníky</Link>
            <Link to="/krkonose" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Krkonoše</Link>
            <Link to="/sumava" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Šumava</Link>
          </div>

          <div className="footer__column">
            <h4 className={darkMode ? 'dark-text' : 'light-text'}>Kam se vydat...?</h4>
            <Link to="/beskydy/kamsevydat" className={darkMode ? 'dark-second-text' : 'light-second-text'}>v Beskydech</Link>
            <Link to="/jeseniky/kamsevydat" className={darkMode ? 'dark-second-text' : 'light-second-text'}>v Jeseníkách</Link>
            <Link to="/krkonose/kamsevydat" className={darkMode ? 'dark-second-text' : 'light-second-text'}>v Krkonoších</Link>
            <Link to="/sumava/kamsevydat" className={darkMode ? 'dark-second-text' : 'light-second-text'}>na Šumavě</Link>
          </div>

          <div className="footer__column footer__column--mobile">
            <h4 className={darkMode ? 'dark-text' : 'light-text'}>Informace</h4>
            <Link to="/jaksesbalitnahory" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Jak se sbalit na hory</Link>
            <Link to="/profile" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Profil</Link>
            <Link to="/kontakt" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Kontakt</Link>
          </div>

          {/* <div className="footer__column footer__column--mobile">
            <h4 className={darkMode ? 'dark-text' : 'light-text'}></h4>
            <Link to="" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Kam se vydat?</Link>
            <Link to="" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Analytics</Link>
            <Link to="" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Commerce</Link>
            <Link to="" className={darkMode ? 'dark-second-text' : 'light-second-text'}>Insights</Link>
          </div> */}
        </div>

        <div className="footer__copyright">
          <p className={darkMode ? 'dark-second-text' : 'light-second-text'}>© 2022 České pohoří</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
